/**
 * IIFE entry: exposes shared EMR PDF builders on `window.PortalPatientPdf` for the static portal.
 */
import { PORTAL_PDF_BUILDERS, buildPortalRecordPdf } from './portalPatientPdf';

if (typeof globalThis !== 'undefined') {
    globalThis.__PORTAL_PDF_SIGNATURE_PATH__ = 'signatures/dr-signature-ar-print.png';
}

const api = {
    PORTAL_PDF_BUILDERS,
    buildPortalRecordPdf,
};

if (typeof window !== 'undefined') {
    window.PortalPatientPdf = api;
}

export default api;
